import Swiper, { Navigation, Pagination } from 'swiper';

function ServicesA1() {
    Swiper.use([Navigation, Pagination]);

    const activeClass = isMobileSafari() ? 'is-active-safari' : 'is-active';

    $('[data-module="servicesA1"]').each(function () {
        let previousWidth = getWidth();

        let swiper = new Swiper($(this).find('[data-slider]')[0], {
            slidesPerView: 'auto',
            loop: true,
            loopAdditionalSlides: 3,
            noSwipingSelector: 'a',
            navigation: {
                prevEl: '.js-slider-prev',
                nextEl: '.js-slider-next',
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'progressbar',
            },
            on: {
                beforeResize: (swiper) => {
                    let currentWidth = getWidth();

                    if (currentWidth !== previousWidth) {
                        swiper.slides.forEach((slide) =>
                            slide.classList.remove(activeClass),
                        );
                    }
                },
                slideChange: (swiper) => {
                    swiper.slides.forEach((slide) =>
                        slide.classList.remove(activeClass),
                    );
                    swiper.slides[swiper.activeIndex].classList.add(
                        activeClass,
                    );
                },
            },
        });

        window.addEventListener('resize', function () {
            let currentWidth = getWidth();

            if (currentWidth !== previousWidth) {
                swiper.update();

                previousWidth = currentWidth;
            }
        });
    });
}

function isMobileSafari() {
    const ua = navigator.userAgent;

    return (
        /Safari/.test(ua) &&
        !/Chrome|CriOS|FxiOS|EdgiOS/.test(ua) &&
        /iPhone|iPad|iPod/.test(ua)
    );
}

function getWidth() {
    return Math.round(
        (window.visualViewport && window.visualViewport.width) ||
            window.innerWidth,
    );
}

export default ServicesA1;
